import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import "../CSS/styles.css"; // Make sure you have this for additional custom styling
import Box from '@mui/material/Box';
export default function AlwaysOnBoolingIcon() {
  const navigate = useNavigate();

  // Handler to navigate to booking form
  const handleClick = () => {
    navigate('/booking'); // This assumes you have a route for booking form
  };

  return (
    <Box>
    <div className="alwaysOnBookingIcon">
      <Button
        variant="contained"
        color="alwaysIcon"
        onClick={handleClick}
        startIcon={<DirectionsCarIcon />}
        className="booking-button"
      >
        Book Your Ride
      </Button>
    </div>
    <div className="alwaysOnBookingIcon-phone" style={{marginTop:'200px'}}>
      
    <a href="tel:9965821750" style={{cursor:'pointer'}}><img src="/images/login/Dashboard/Assert/phone.webp" alt="always call 9965821750 just call and book" width={50} height={50}/></a>
    </div>

    </Box>
  );
}
